import { render, staticRenderFns } from "./proc_info.vue?vue&type=template&id=87c35cd6&"
import script from "./proc_info.vue?vue&type=script&lang=js&"
export * from "./proc_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports